<template>
    <BarChart
        :chart-data="chartData"
        :options="options"
        :height="200"
        :width="1036"
    />
</template>

<script>

/**
 * External dependencies
 */
import { BarChart } from 'vue-chart-3';

/**
 * Internal dependencies
 */
import abbreviateNumber from '@/utils/abbreviateNumber';
import setupChartJs from '@//utils/setupChartJs';

setupChartJs();

export default {
    components: {
        BarChart,
    },

    props: {
        data: {
            type: Array,
            default: null,
        },
        timeUnit: {
            type: String,
            default: 'day',
        },
    },

    computed: {
        /**
         * Returns computed chart options.
         *
         * @returns {object} Chart options.
         */
        options() {
            return {
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                responsive: true,
                scales: {
                    x: {
                        grid: {
                            display: false,
                            drawBorder: false,
                            offset: false,
                        },
                        offset: true,
                        time: {
                            unit: this.timeUnit,
                        },
                        type: 'time',
                    },
                    y: {
                        grid: {
                            drawBorder: false,
                            color: '#E9E7EE',
                            ticks: {
                                padding: 11,
                            },
                        },
                        ticks: {
                            callback: (value) => abbreviateNumber(value, 0),
                        },
                    },
                },
            };
        },

        /**
         * Returns prepared chart data.
         *
         * @returns {object} Chart data.
         */
        chartData() {
            const data = this.data.map(item => ({
                x: item.bucket,
                y: parseInt(item.totalListens),
            }));

            return {
                datasets: [
                    {
                        backgroundColor: '#632ADB',
                        borderRadius: 5,
                        data,
                        hoverBackgroundColor: '#170F36',
                        label: 'Listens',
                        maxBarThickness: 46,
                    },
                ],
            };
        },
    },
};
</script>
